import axios from 'axios';

// For common config
axios.defaults.headers.post['Content-Type'] = 'application/json';

const wpBase = axios.create({
  baseURL: 'https://www.finditz.com',
});

const mcBase = axios.create({
  baseURL: 'https://mc-api.marketcheck.com',
});

export { wpBase, mcBase };
